import React from 'react';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import TagIcon from '@mui/icons-material/Tag';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PersonIcon from '@mui/icons-material/Person';
import StorefrontIcon from '@mui/icons-material/Storefront';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { TFunction } from 'i18next';

export type ReturnFilterChipItem = {
    icon: React.JSX.Element;
    tooltip: string;
    value: string;
    colorKey: number;
};

const pushIf = (chips: ReturnFilterChipItem[], condition: boolean, chip: ReturnFilterChipItem) => {
    if (condition) chips.push(chip);
};

export const buildReturnListFilterChips = (
    request: any,
    t: TFunction,
    returnStatus: any[] | undefined
): ReturnFilterChipItem[] => {
    const chips: ReturnFilterChipItem[] = [];

    pushIf(chips, !!(request.StartDate || request.EndDate), {
        icon: <CalendarTodayIcon />,
        tooltip: `${t('general.startDate')} / ${t('general.endDate')}`,
        value: `${request.StartDate || '?'}  →  ${request.EndDate || '?'}`,
        colorKey: 0,
    });
    pushIf(chips, !!(request.RMACode && Number(request.RMACode) !== 0), {
        icon: <ConfirmationNumberIcon />,
        tooltip: t('refundList.rmacode'),
        value: String(request.RMACode),
        colorKey: 1,
    });
    pushIf(chips, !!(request.OrderNumber && request.OrderNumber !== 0), {
        icon: <ReceiptLongIcon />,
        tooltip: t('general.orderNo'),
        value: String(request.OrderNumber),
        colorKey: 2,
    });
    pushIf(chips, !!(request.OrderId && request.OrderId !== 0), {
        icon: <TagIcon />,
        tooltip: t('general.orderId'),
        value: String(request.OrderId),
        colorKey: 3,
    });
    pushIf(chips, !!(request.ReturnId && request.ReturnId !== 0), {
        icon: <AssignmentReturnIcon />,
        tooltip: t('return.returnId'),
        value: String(request.ReturnId),
        colorKey: 4,
    });
    pushIf(chips, !!(request.ShippingListNo && request.ShippingListNo !== 0 && request.ShippingListNo !== ''), {
        icon: <ListAltIcon />,
        tooltip: t('general.shippingNo'),
        value: String(request.ShippingListNo),
        colorKey: 5,
    });
    pushIf(chips, !!(request.ShippingListId && request.ShippingListId !== 0), {
        icon: <LocalShippingIcon />,
        tooltip: t('general.shippingId'),
        value: String(request.ShippingListId),
        colorKey: 6,
    });
    pushIf(chips, !!(request.shippingListNo && request.shippingListNo !== '' && request.shippingListNo !== 0), {
        icon: <ListAltIcon />,
        tooltip: t('general.shippingNo'),
        value: String(request.shippingListNo),
        colorKey: 5,
    });
    pushIf(chips, !!(request.CustomerId && request.CustomerId !== 0), {
        icon: <PersonIcon />,
        tooltip: t('general.customerId'),
        value: String(request.CustomerId),
        colorKey: 7,
    });
    pushIf(chips, !!(request.StoreCode && request.StoreCode !== ''), {
        icon: <StorefrontIcon />,
        tooltip: t('general.storeCode'),
        value: request.StoreCode,
        colorKey: 8,
    });

    if (request.Barcodes && request.Barcodes.length > 0) {
        const barcodeStr = Array.isArray(request.Barcodes) ? request.Barcodes.join(', ') : request.Barcodes;
        chips.push({
            icon: <QrCodeScannerIcon />,
            tooltip: t('searchService.barcode'),
            value: barcodeStr,
            colorKey: 9,
        });
    }

    pushIf(chips, !!(request.CargoReturnCode && request.CargoReturnCode !== ''), {
        icon: <LocalShippingIcon />,
        tooltip: t('general.cargoReturnCode'),
        value: request.CargoReturnCode,
        colorKey: 6,
    });

    if (request.Status && request.Status !== null) {
        chips.push({
            icon: <CheckCircleIcon />,
            tooltip: t('general.status'),
            value: (returnStatus || []).find((status: any) => +status.returnStatusId === +request.Status)
                ?.statusDescription,
            colorKey: 6,
        });
    }

    return chips;
};
